import React, { useCallback, useEffect, useReducer, useState } from 'react';
import axios from 'axios';
// import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { usePoll, useMediaModal, Button, ButtonWithLoading, Content, ButtonWithIcon, Icon, Label, LineReducer, LineSetContext, LineUI, SelectField, SmallInput, Spinner, Switch, PageHeader, FilterDropdown, useModal, useNotification, AlertBar, TextAreaField } from 'scorer-ui-kit';
import { useHistory, } from 'react-router';
import { Divider } from 'Styles';
import styled, { css } from 'styled-components';
import { getStaticData, getAreaData, saveArea, getSegStatus, getErrAreaName, getViewImgResult/*, getVQASetting*/, getVQAMaster, getSchedule/*, getAlgorithmType*/, getAlertData} from 'services/apiConfig';
import { useTranslation } from 'react-i18next';
import BoxModal from 'components/BoxModal';
import { BASE_API_URL, EDGE_API_BASE_URL } from '../../constants';
import i18n from 'i18n';
import AwaitingStreamEn from '../../svg/img_awaiting_stream_en.jpg';
import AwaitingStreamJp from '../../svg/img_awaiting_stream_jp.jpg';
import dayjs from 'dayjs';

const MainContent = styled.div`
  margin-top: -5px;
  max-width: 940px !important;
`;

const Header = styled.div`
  width: 100%;
  max-width: 940px !important;
  height: 108px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  line-height: 1.2;
  > div:first-child > div > a {
    max-width: 750px;
    overflow-wrap: break-word;
    white-space: break-spaces;
    bottom: 34.5px;
    top: unset;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const PageHeaderComponent = styled.div`
  display: flex;
  flex-direction: column;
`;

const CancelButton = styled(Button)`
  background: #e4edf4;
  :hover:enabled {
    background: #d4e4f0;
  }
  :disabled {
    background: #e9f0f6;
  }
`;


/*const SettingsContainer = styled.div`
  width: 100%;
  max-width: 940px !important;
  margin: 9px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;*/

const InputAndButtonContainer = styled.div<{ gap: string }>`
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: ${({ gap }) => gap};
  & > button {
    background: #e4edf4;
    :hover:enabled {
      background: #d4e4f0;
    }
    :disabled {
      background: #e9f0f6;
    }
  }
`;


const DividerWithMargin = styled(Divider)`
  margin: 14px 0 12px;
`;

const SidePaddingDiv = styled.div`
  position: relative;
  padding: 0 20px;
`;



const LabelWithMargin = styled(Label)`
  margin-bottom: 10px;
  & > span {
    margin-bottom: 10px;
  }
  font-size: 12px;
`;


const StyledSmallInputWithLabel = styled(SmallInput) <ISmallInput>`
  & > label {
    width: ${({ length }) => length};
    margin-bottom: 0;
    font-size: 12px;
  }
`;

const StyledSmallInputWithLabel2 = styled(SmallInput) <ISmallInput>`
  & > label {
    width: ${({ length }) => length};
    margin-bottom: 0;
    font-size: 12px;
    & > span {width: 150px;}
  }
`;



const StyledSmallInput2 = styled(SmallInput) <ISmallInput>`
  width: ${({ length }) => length};
  min-height: 30px;
  & > label {
    margin-bottom: 0;
    font-size: 12px;
  }
  & > label > div {
    width: 100%;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
`;


const StyledSelectField = styled(SelectField)`
  width: 209px;
  background: #fff;
  &:disabled {
    opacity: 0.7;
  }
  & + div {
    top: 50% !important;
    transform: translateY(-50%) !important;
  }
`;


const LineSelectFieldContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;
  position: relative;
  & > div:first-child {
    position: absolute;
    top: 6px;
    left: -24px;
  }
`;

const LineSettingsContainer = styled.div`
  width: 100%;
  max-width: 940px !important;
  margin: 20px 0;
`;

// const LineUILeftPanel = styled.div`
//   padding: 15px 0;
//   width: 100%;
//   flex-shrink: 0;
//   position: relative;
// `;

const LineUIImageWrapper = styled.div<{ isReadOnly: boolean }>`
  width: 100%;
  height: 390px;
  position: relative;
  & > div {
    height: 100%;
    display: flex;
    justify-content: center;
    > img {
      width: max-content;
      box-shadow: -2px 0 0 0 #ddd, 2px 0 0 0 #ddd;
    }
    & > div > svg > g:nth-child(n) {
      > text {
        display:none;
      }
      // > g:nth-child(n) {
      //   > text {
      //     display: none;
      //   }
      // }
    }
    
  }
  ${({ isReadOnly }) => isReadOnly && css`
    ::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
    }
  `}
`;


const SpinnerContainer = styled.div<{ backgroundColor?: string }>`
  width: 100%;
  height: 100%;
  border-radius: 3px;
  ${({ backgroundColor }) => css`
    background-color: ${backgroundColor ? backgroundColor : 'rgba(0, 0, 0, 0.35)'};
  `};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 4;
`;

const LineUIContainer = styled.div`
  width: 100%;
  max-width: 940px !important;
  display: flex;
  margin: 30px 0 15px;
  position: relative;
  border-radius: 3px;
  background-color: #fafcfc;
  box-shadow: 0 4px 9px 0 rgba(152, 174, 189, 0.05);
  border: solid 1px #eee;
  flex-direction: column;
  &::before {
    content: "";
    width: 14.5px;
    height: 51px;
    position: absolute;
    top: -26px;
    left: -16px;
    border-left: 1px solid #d9dad9;
    border-bottom: 1px solid #d9dad9;
  }
`;


const ButtonContainer = styled.div`
  margin-top: -14px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 10px 0;
  & > button {
    min-width: 155px;
  }
`;

const LineUILeftPanel = styled.div`
  padding: 15px 0;
  float: left;
  width: 30%;
`;

const LineUIRightPanel = styled.div`
  width: 100%;
  float: right;
  width: 70%;
`;

const LineUIBottomPanel = styled.div`
  padding: 15px 0;
  width: 100%;
  bottom: 0px;
`;

const TargetAndEditContainer = styled.div`
  display: flex;
`;

const EditButton = styled(FilterDropdown)`
  & > div > div > button {
    width: 40px;
    height: 20px;
    & > div > div {
      width: 10px;
      :nth-child(2) { font-size: 10px; }
      :nth-child(3) { display: none; }
    }
  }
  margin-left: 5px;
`;

const ConfirmBox = styled.div`
`;

const ConfirmButtonBox = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  & > button:first-child{
    margin-right: 10px;
    background: #e4edf4;
  }
`;

const ButtonFormat = styled(Button)`
  &:focus {
    outline: 2px solid #838383;
  }
`;

const ButtonWithIconFormat = styled(ButtonWithIcon)`
  &:focus {
    outline: 2px solid #838383;
  }
`;

const ConfirmText = styled(Label)`
  font-size: 20px;
`;

const StyledLabelAlgorithm = styled(Label)`
  color: hsl(200deg 49.09% 72.86%);
  font-size: 12px;
  position: relative;
  top: -20px;
  margin-bottom: unset;
`;

const StyledAlgorithmText = styled.div`
  font-size: 15px;
  position: relative;
  top: -15px;
`;

const AlertContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
`;
const VQAContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const WrapTextField = styled.div`
  & span {
    width: 250px;
  }

  & input {
    min-height: 30px;
  }

  & select {
    height: 30px;
  }
`;

const TextFieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-weight: 500;
  align-items: center;
  justify-content: left;

  & p {
    width: 185px;
  }

  & label {
    width: 70%;
    min-height: 30px;
  }
`;

const ContinueTimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  & span {
    width: 150px;
  }
`;

const ScheduleContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 5px;
  /* justify-content: space-between; */
  column-gap: 9px;
  align-items: center;
  margin-bottom: 10px;
  font-size: 10px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  color: #4b4b4b;
`;
const SelectAndScheduleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 70%;
  min-height: 30px;
`;

const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  float: left;
  width: 30%;
`;

const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  float: right;
  width: 70%;
`;


interface ISmallInput {
  length: string;
}

interface IImageResponse {
  data: ArrayBuffer,
  status: number,
}

interface IParams {
  streamName: string;
}


const CAMERA_IMAGE_REFRESH_INTERVAL = 5;


const CameraConfiguration: React.FC = React.memo(() => {
  const history = useHistory();
  const { isMediaUrlValid } = useMediaModal();
  const { streamName } = useParams<IParams>();
  const { t } = useTranslation(['CommonDict']);
  const lang = i18n.language === 'ja' ? 'ja' : 'en';
  const { sendNotification } = useNotification();
  const { createModal, setModalOpen } = useModal();
  const [state, dispatch] = useReducer(LineReducer, []);
  const [state_edit, dispatch_edit] = useReducer(LineReducer, []);

  const [analysisType, setAnalysisType] = useState('');
  const [decisionPoint, setDecisionPoint] = useState<any>({});
  const [segArea, setSegArea] = React.useState<any>('');
  const [segAreaSize, setSegAreaSize] = useState<any>('');
  const [segThreshold, setSegThreshold] = useState<any>('');
  const [detectionThreshold, setDetectionThreshold] = useState<any>('');
  const [alertConTime, setAlertConTime] = useState<any>('');
  const [alertConHoldTime, setAlertConHoldTime] = useState<any>('');
  const [probThreshold, setProbThreshold] = useState<any>('');
  const [minWidth, setMinWidth] = useState<any>('');
  const [maxWidth, setMaxWidth] = useState<any>('');
  const [minHeight, setMinHeight] = useState<any>('');
  const [maxHeight, setMaxHeight] = useState<any>('');
  const [pointNumber, setPointNumber] = useState<any>('');
  const [isAnalysisEnabled, setIsAnalysisEnabled] = useState<boolean>(false);
  const [imageDetails, setImageDetails] = useState({ x: 1920, y: 1080 });
  const [image, setImage] = useState('');
  const [imageLoading, setImageLoading] = useState<boolean>(true);
  const [isReadOnly, setIsReadOnly] = useState<boolean>(false);
  const [saveLoading, setSaveLoading] = useState<boolean>(false);
  const [showEditArea, setShowEditArea] = useState<boolean>(false);

  const [areaData, setAreaData] = useState<any[]>([]);
  const [selectedAreaID, setSelectedAreaID] = React.useState<any>('');
  const [detectionPoint, setDetectionPoint] = useState([]);
  const [segmentation, setSegmentation] = useState([{'name': 'dumy', 'formula': {'value': [249,241,212]}}]);  
  const [objectTarget, setObjectTarget] = useState([]);
  const [selectedObjectTarget, setSelectedObjectTarget] = useState<any>([]);
  const [camAlgorithmType, setCamAlgorithmType] = useState('');
  const [segStatus, setSegStatus] = useState<any>();
  const [vqaStatus, setVqaStatus] = useState<any>();
  const [saveDisabled, setSaveDisabled] = useState<boolean>(false);
  const [isNameExist, setIsNameExist] = useState<boolean>(false);
  const [errAreaList, setErrAreaList] = useState<any[]>([]);

  const [defaultAreaName, setDefaultAreaName] = useState('');    
  const [timeUnit, setTimeUnit] = useState<any>({unit1: 'sec', unit2: 'sec'});
  const [imageType, setImageType] = useState('LiveImg');
  const [originalImgList, setOriginalImgList] = useState<any[]>([{'name': '', 'value': ''}]);
  const [resultImgList, setResultImgList] = useState<any[]>([{'name': '', 'value': ''}]);  
  const [image2, setImage2] = useState('');

  const dbName = 'static_image_analysis';
  const storeName = 'cameraData';
  //const [vqaSettingData, setVqaSettingData] = useState<any>([]);
  const [vqaMasterData, setVqaMasterData] = useState<any>([]);
  const [schedule, setSchedule] = useState<any>([]);
  const [vqaMasterID, setVqaMasterID] = useState<string>('');
  const [scheduleID, setScheduleID] = useState<any>('');
  const [selectedModel, setSelectedModel] = useState('');
  const [openTimeWindow, setOpenTimeWindow] = useState<any>([]);
  const [openDay, setOpenDay] = useState<any>([]);

  const [alertData, setAlertData] = useState<any>({});
  const [patliteEnable, setPatliteEnable] = useState<boolean>(true);
  const [emailEnable, setEmailEnable] = useState<boolean>(true);
  const [activePatlite, setActivePatlite] = useState<any>('');
  const [activeEmails, setActiveEmails] = useState<any>([]);

  /*const fetchSettingData = useCallback(async () => {
    try {
      const res = await getVQASetting({camName: streamName});
      if (res.status === 200 && res.data) {        
        setVqaSettingData(res.data.data);
      }
    } catch (error){
      console.error(error);
    }
  }, [streamName]);*/
  const fetchAlertData = useCallback(async () => {
    try {
      const res = await getAlertData();
      if (res.status === 200 && res.data) {
        setAlertData(res.data.data);
      }
    } catch (error){
      console.error(error);
    }
  }, []);

  const fetchVQAMaster = useCallback(async () => {
    try {
      const res = await getVQAMaster();
      if (res.status === 200 && res.data) {
        setVqaMasterData(res.data.data);
        setSelectedModel(res.data.data[0].vqa_model);
      }
    } catch (error){
      console.error(error);
    }
  }, []);

  const fetchSchedule = useCallback(async () => {
    try {
      const res = await getSchedule();
      if (res.status === 200 && res.data) {
        setSchedule(res.data.data);
      }
    } catch (error){
      console.error(error);
    }
  }, []);

  useEffect(() => {
    fetchVQAMaster();
    fetchSchedule();
    fetchAlertData();
  },[fetchSchedule, fetchVQAMaster, fetchAlertData]);

  const getViewImg = useCallback(async() => {
    try {
      const res = await getViewImgResult({'streamVal': streamName});
      if(res.status === 200) {
        setOriginalImgList(res.data.original_img_list);
        setResultImgList(res.data.result_img_list);
      }else{
        console.error('getViewImg error');
      }
    } catch (err) {
      console.error(err);
    }
  }, [streamName]);
  useEffect(()=>{getViewImg();}, [getViewImg]);
  usePoll(async () => {getViewImg();}, (1000 * 60));
  
    
  //-- Image Button --//
  const handleImageType = useCallback((e:any) => {
    setImageType(e);
  }, []);

  useEffect(()=>{
    let imageValue;
    if(imageType === 'originalImg'){
      imageValue = originalImgList.find(x => x.name === state[Number(selectedAreaID)].name)?.value;
    } else if(imageType === 'resultImg'){
      imageValue = resultImgList.find(x => x.name === state[Number(selectedAreaID)].name)?.value;
    }
    setImage2(imageValue || (lang === 'ja' ? AwaitingStreamJp : AwaitingStreamEn));
  }, [imageType, originalImgList, resultImgList, selectedAreaID, state, lang]);


  // init ------------------ 
  const getErrArea = useCallback(async() => {
    try {
      const res = await getErrAreaName({'streamName': streamName});
      if(res.status === 200){
        setErrAreaList(res.data.err_area_list);
      }
      else console.error('getErrArea error');
    } catch (err) {console.error(err);}
  }, [streamName]);
  useEffect(()=>{getErrArea();}, [getErrArea]);
  usePoll(async () => {getErrArea();}, (1000 * 60));

  const getJsonData = useCallback(async() => {
    const request = indexedDB.open(dbName, 1);
    request.onerror = (e) => console.error('Database error:', (e.target as IDBOpenDBRequest).error);
    request.onsuccess = (e) => {
      const db = (e.target as IDBOpenDBRequest).result;
      const transaction = db.transaction(storeName, 'readonly');
      const store = transaction.objectStore(storeName);
      const getRequest = store.get('allCameraData');
      getRequest.onerror = (e) => console.error('GetAll request error:', (e.target as IDBOpenDBRequest).error);
      getRequest.onsuccess = async() => {
        if (getRequest.result){
          const allCameraData = getRequest.result.data;
          const targetObject = allCameraData.find((item: any) => item.stream_name === streamName);

          setCamAlgorithmType(targetObject.algorithm_type);
          setAnalysisType(targetObject.algorithm_type.split(',')[0]);
          setVqaStatus(targetObject.algorithm_type.includes('VQA') ? 1 : 0);
          
          try{
            const res = await getStaticData({'algorithm_type': targetObject.algorithm_type});
            if (res.status === 200 && res.data) {
              const data: any = res.data.data;
              setDetectionPoint(data.detection_point);
              setSegmentation(data.segmentation);
              setObjectTarget(data.object_target.flatMap((x: string) => ({ text: x, value: x })));
            }

          } catch (error){
            console.error(error);
          }
        }
      };
    };

  }, [streamName]);
  useEffect(() => {
    getJsonData();
  }, [getJsonData]);

  // Tien - 2023.11.23
  const getSegmentationStatus = useCallback(async () => {
    try{
      const res = await getSegStatus({camName: streamName});
      if (res.status === 200 && res.data) {
        setSegStatus(res.data.data[0].segmentation_status);
      }
    } catch (error){
      console.error(error);
    }
  }, [streamName]);
  useEffect(()=>{
    getSegmentationStatus();
    if(segStatus === 0 && analysisType.toLowerCase() === 'ratio') {
      setSaveDisabled(true);
    }
  }, [getSegmentationStatus, analysisType, segStatus]);
  usePoll(async () => {getSegmentationStatus();}, (1000 * 60));
  // ---------- 



  // function ------------------ 
  const hideLineUI = useCallback((index: any) => {
    const lineUI = document.getElementById('lineui-id');
    if (lineUI) {
      const svg: any = lineUI.querySelector('svg');
      if (svg) {
        for (let i = 0; i < svg.children.length; i++) {
          if (index) {
            if (i !== Number(index)) {
              svg.children[i].style.display = 'none';
            } else {
              svg.children[i].style.display = '';

            }
          } else {
            svg.children[i].style.display = '';
          }
        }
      }
    }
  }, []);

  function isEmpty(obj: any) {
    for (const x in obj) {
      return false;
    }
    return true;
  }
  // ---------- 



  
  // step 3 ------------------ 
  // -------- show Area Data ----------
  useEffect(() => {
    const index = Number(selectedAreaID);
    if (areaData[index]) {
      setVqaMasterID(areaData[index].vqa_master_id ? areaData[index].vqa_master_id : vqaMasterData.length===0 ? 0 : vqaMasterData[0].id );
      setScheduleID(areaData[index].schedule_id ? areaData[index].schedule_id : schedule.length===0 ? 0 : schedule[0].id);
      if(camAlgorithmType === 'VQA'){
        setAnalysisType(camAlgorithmType);
      }else{
        setAnalysisType(areaData[index].analysis_type);
      }
      setProbThreshold(areaData[index].probThreshold);
      setMinWidth(areaData[index].minWidth);
      setMaxWidth(areaData[index].maxWidth);
      setMinHeight(areaData[index].minHeight);
      setMaxHeight(areaData[index].maxHeight);
      setSegArea(areaData[index].segArea);
      setDecisionPoint(areaData[index].decisionPoint);
      setSegAreaSize(areaData[index].segAreaSize);
      setSegThreshold(areaData[index].segThreshold);
      setDetectionThreshold(areaData[index].detectionThreshold);
      if(timeUnit.unit1 === 'hour'){
        setAlertConTime(Math.floor(areaData[index].alertConTime/3600));
      } else if(timeUnit.unit1 === 'min'){
        setAlertConTime(Math.floor(areaData[index].alertConTime/60));
      } else if(timeUnit.unit1 === 'sec'){
        setAlertConTime(areaData[index].alertConTime);
      }
        
      if(timeUnit.unit2 === 'hour'){
        setAlertConHoldTime(Math.floor(areaData[index].alertConHoldTime/3600));
      } else if(timeUnit.unit2 === 'min'){
        setAlertConHoldTime(Math.floor(areaData[index].alertConHoldTime/60));
      } else if(timeUnit.unit2 === 'sec'){
        setAlertConHoldTime(areaData[index].alertConHoldTime);
      }
      setIsAnalysisEnabled(areaData[index].enabled);
      setPointNumber(t('Area Sides')+(areaData[index].points.length));

      const targetArray = areaData[index].target;
      const arr = objectTarget.filter(function (o: any) { return targetArray.includes(o.value); });
      setSelectedObjectTarget(arr);

      //alert settings
      setPatliteEnable(areaData[index].patlite_settings.enabled);
      setActivePatlite(areaData[index].patlite_settings.activePatlite);
      setEmailEnable(areaData[index].email_settings.enabled);
      setActiveEmails(areaData[index].email_settings.activeEmails);

      if (state.length){
        const new_state = JSON.parse(JSON.stringify(state[index]));
        dispatch_edit({
          type: 'LOAD',
          state: [new_state],
        });
      }
    }
  }, [camAlgorithmType, areaData, selectedAreaID, objectTarget, t, state, timeUnit, vqaMasterData, schedule]);
  // --------


  // step 2 ------------------ 
  // -------- select edit area ----------
  const selectEditArea = useCallback((e) => {
    setSelectedAreaID(e);
    hideLineUI(e);
  }, [hideLineUI]);
  // --------
  useEffect(() => {
    if(analysisType.toLowerCase() === 'ratio' && segStatus === 0) {
      setSaveDisabled(true);
    } else {
      setSaveDisabled(false);
    }
  },[analysisType, segStatus]);

  useEffect(() => {
    if(analysisType.toLowerCase() === 'vqa') {
      setSaveDisabled(vqaMasterData.length===0 || schedule.length===0);
    }
  },[analysisType, vqaMasterData, schedule]);


  // step 1 ------------------ 
  // -------- get Area Data ----------
  const fetchAreas = useCallback(async () => {
    if (streamName) {
      try {
        const res: any = await getAreaData({camName: streamName});
        if (res.status === 200 && res.data) {
          const data: any = res.data.data;
          if (!isEmpty(data)) {
            setAreaData(data);
            dispatch({
              type: 'LOAD',
              state: data,
            });
          }
        }
      }
      catch (error) {
        console.error(error);
      }
    }
  }, [streamName]);
  useEffect(() => {
    fetchAreas();
  }, [fetchAreas]);
  // --------


  // step 4 ------------------ 
  // -------- handle Area config ----------
  const handleCameraEnable = useCallback((e: boolean) => {
    const index = Number(selectedAreaID);
    const new_areaData = JSON.parse(JSON.stringify(areaData));
    new_areaData[index].enabled = e;
    setIsAnalysisEnabled(e);
    setAreaData(new_areaData);
  }, [selectedAreaID, areaData]);

  const handleAnalysisType = useCallback((e) => {
    const index = Number(selectedAreaID);
    const new_areaData = JSON.parse(JSON.stringify(areaData));
    new_areaData[index].analysis_type = e;
    setAnalysisType(e);
    setAreaData(new_areaData);
  }, [selectedAreaID, areaData]);

  const handleRatioConfig = useCallback((e, type) => {
    const index = Number(selectedAreaID);
    const new_areaData = JSON.parse(JSON.stringify(areaData));
    if (type === 'selectSegArea'){
      const found: any = segmentation.find((obj: any) => {return obj.name === e;});
      new_areaData[index].segArea = e;
      new_areaData[index].segPixelVal = found ? found.formula.value : [];
      setSegArea(e);
    }
    else if (type === 'setSegThreshold'){
      const value = e > 100 ? 100 : e < 0 ? 1 : Number(e);
      new_areaData[index].segThreshold = value ;
      setSegThreshold(value);
    }
    else if (type === 'setAlertConTime'){
      let value = e < 0 ? 1 : Number(e);
      setAlertConTime(value);
      if(timeUnit.unit1 === 'sec'){
        // 秒単位の場合：0-86400秒（24時間）
        value = Math.min(Math.max(Number(e), 0), 86400);
      }
      else if(timeUnit.unit1 === 'hour'){
        // 時間単位の場合：0-24時間
        value = Math.min(Math.max(Number(e), 0), 24) * 60 * 60;
      }
      else if(timeUnit.unit1 === 'min'){
        // 分単位の場合：0-1440分（24時間）
        value = Math.min(Math.max(Number(e), 0), 1440) * 60;
      }
      new_areaData[index].alertConTime = value ;
    }
    else if (type === 'setAlertConHoldTime'){
      let value = e < 0 ? 1 : Number(e);
      setAlertConHoldTime(value);
      if(timeUnit.unit2 === 'sec'){
        // 秒単位の場合：0-86400秒（24時間）
        value = Math.min(Math.max(Number(e), 0), 86400);
      }
      else if(timeUnit.unit2 === 'hour'){
        // 時間単位の場合：0-24時間
        value = Math.min(Math.max(Number(e), 0), 24) * 60 * 60;
      }
      else if(timeUnit.unit2 === 'min'){
        // 分単位の場合：0-1440分（24時間）
        value = Math.min(Math.max(Number(e), 0), 1440) * 60;
      }
      new_areaData[index].alertConHoldTime = value ;
    }
    setAreaData(new_areaData);
  }, [selectedAreaID, areaData, segmentation, timeUnit]);

  const handleCountConfig = useCallback((e, type) => {
    const index = Number(selectedAreaID);
    const new_areaData = JSON.parse(JSON.stringify(areaData));
    if (type === 'selectSegArea'){
      const found: any = segmentation.find((obj: any) => {return obj.name === e;});
      new_areaData[index].segArea = e;
      new_areaData[index].segPixelVal = found ? found.formula.value : [];
      setSegArea(e);
    }
    else if (type === 'setSelectedObjectTarget'){
      new_areaData[index].target = e ? e.map((item: any) => item.text) : [];
      if(e !== null){
        setSelectedObjectTarget(e);
      } else{
        setSelectedObjectTarget([]);
      }
    }
    else if (type === 'setDecisionPoint'){
      new_areaData[index].decisionPoint = e;
      setDecisionPoint(e);
    }
    else if (type === 'setSegAreaSize'){
      const value = e < 0 ? 1 : Number(e);
      new_areaData[index].segAreaSize = value ;
      setSegAreaSize(value);
    }
    else if (type === 'setSegThreshold'){
      const value = e > 100 ? 100 : e < 0 ? 1 : Number(e);
      new_areaData[index].segThreshold = value ;
      setSegThreshold(value);
    }
    else if (type === 'setDetectionThreshold'){
      const value = e < 0 ? 1 : Number(e);
      new_areaData[index].detectionThreshold = value ;
      setDetectionThreshold(value);
    }
    else if (type === 'setProbThreshold'){
      const value = e > 100 ? 100 : e < 0 ? 1 : Number(e);
      new_areaData[index].probThreshold = value ;
      setProbThreshold(value);
    }
    else if (type === 'setMinWidth'){
      const value = e < 0 ? 1 : Number(e);
      new_areaData[index].minWidth = value ;
      setMinWidth(value);
    }
    else if (type === 'setMaxWidth'){
      const value = e < 0 ? 1 : Number(e);
      new_areaData[index].maxWidth = value ;
      setMaxWidth(value);
    }
    else if (type === 'setMinHeight'){
      const value = e < 0 ? 1 : Number(e);
      new_areaData[index].minHeight = value ;
      setMinHeight(value);
    }
    else if (type === 'setMaxHeight'){
      const value = e < 0 ? 1 : Number(e);
      new_areaData[index].maxHeight = value ;
      setMaxHeight(value);
    }
    else if (type === 'setAlertConTime'){
      let value = e < 0 ? 1 : Number(e);
      setAlertConTime(value);
      if(timeUnit.unit1 === 'sec'){
        // 秒単位の場合：0-86400秒（24時間）
        value = Math.min(Math.max(Number(e), 0), 86400);
      }
      else if(timeUnit.unit1 === 'hour'){
        // 時間単位の場合：0-24時間
        value = Math.min(Math.max(Number(e), 0), 24) * 60 * 60;
      }
      else if(timeUnit.unit1 === 'min'){
        // 分単位の場合：0-1440分（24時間）
        value = Math.min(Math.max(Number(e), 0), 1440) * 60;
      }
      new_areaData[index].alertConTime = value ;
      
    }
    else if (type === 'setAlertConHoldTime'){
      let value = e < 0 ? 1 : Number(e);
      
      setAlertConHoldTime(value);
      if(timeUnit.unit2 === 'sec'){
        // 秒単位の場合：0-86400秒（24時間）
        value = Math.min(Math.max(Number(e), 0), 86400);
      }
      else if(timeUnit.unit2 === 'hour'){
        // 時間単位の場合：0-24時間
        value = Math.min(Math.max(Number(e), 0), 24) * 60 * 60;
      }
      else if(timeUnit.unit2 === 'min'){
        // 分単位の場合：0-1440分（24時間）
        value = Math.min(Math.max(Number(e), 0), 1440) * 60;
      }
      new_areaData[index].alertConHoldTime = value ;
    }
    setAreaData(new_areaData);
  }, [selectedAreaID, areaData, segmentation, timeUnit]);

  const handleVqaConfig = useCallback((e, type) => {
    const index = Number(selectedAreaID);
    const new_areaData = JSON.parse(JSON.stringify(areaData));

    if (type === 'setAlertConTime'){
      let value = e < 0 ? 1 : Number(e);
      setAlertConTime(value);
      if(timeUnit.unit1 === 'sec'){
        // 秒単位の場合：0-86400秒（24時間）
        value = Math.min(Math.max(Number(e), 0), 86400);
      }
      else if(timeUnit.unit1 === 'hour'){
        // 時間単位の場合：0-24時間
        value = Math.min(Math.max(Number(e), 0), 24) * 60 * 60;
      }
      else if(timeUnit.unit1 === 'min'){
        // 分単位の場合：0-1440分（24時間）
        value = Math.min(Math.max(Number(e), 0), 1440) * 60;
      }
      new_areaData[index].alertConTime = value;
    }
    else if (type === 'setAlertConHoldTime'){
      let value = e < 0 ? 1 : Number(e);
      setAlertConHoldTime(value);
      if(timeUnit.unit2 === 'sec'){
        // 秒単位の場合：0-86400秒（24時間）
        value = Math.min(Math.max(Number(e), 0), 86400);
      }
      else if(timeUnit.unit2 === 'hour'){
        // 時間単位の場合：0-24時間
        value = Math.min(Math.max(Number(e), 0), 24) * 60 * 60;
      }
      else if(timeUnit.unit2 === 'min'){
        // 分単位の場合：0-1440分（24時間）
        value = Math.min(Math.max(Number(e), 0), 1440) * 60;
      }
      new_areaData[index].alertConHoldTime = value;
    }
    else if (type === 'vqaMaster'){
      new_areaData[index].vqa_master_id = e ;
      setVqaMasterID(e);
    }
    else if (type === 'schedule'){
      new_areaData[index].schedule_id = e ;
      setScheduleID(e);
    }
    setAreaData(new_areaData);
  }, [selectedAreaID, areaData, timeUnit]);

  const handleVqamodel = useCallback((model_name: any) => {
    const firstItem  = vqaMasterData.find((item: any) => item.vqa_model === model_name);
    const new_areaData = JSON.parse(JSON.stringify(areaData));
    new_areaData[Number(selectedAreaID)].vqa_master_id = firstItem.id ;
    setSelectedModel(model_name);
    setVqaMasterID(firstItem.id);
    setAreaData(new_areaData);
  }, [vqaMasterData, selectedAreaID, areaData]);
  // --------

  const handleAlertConfig = useCallback((e, type) => {
    const index = Number(selectedAreaID);
    const new_areaData = JSON.parse(JSON.stringify(areaData));

    if (type === 'setPatliteEnable'){
      new_areaData[index].patlite_settings.enabled = e ;
      setPatliteEnable(e);
    }
    else if (type === 'setActivePatlite'){
      new_areaData[index].patlite_settings.activePatlite = Number(e);
      setActivePatlite(e);
    }
    else if (type === 'setEmailEnable'){
      new_areaData[index].email_settings.enabled = e ;
      setPatliteEnable(e);
    }
    else if (type === 'setActiveEmail'){
      e = e ? e : [];
      new_areaData[index].email_settings.activeEmails = e.map((x:any)=> x.value) ;
      setActiveEmails(e.map((x:any)=> x.value));
    }
    setAreaData(new_areaData);
  }, [selectedAreaID, areaData]);


  // step 5 ------------------ 
  // -------- save config ----------
  const saveAreas = useCallback(async () => {
    for (let i = 0; i < areaData.length; i++) {
      if (areaData[i].name === '' || areaData[i].name == null) {
        sendNotification({ type: 'error', message: t('Name cannot be empty.') });
        return;
      }
    }
    
    setSaveLoading(true);
    setIsReadOnly(true);

    const new_areaData = areaData.map((item, index) => {
      return { ...item, points: state[index].points };
    });

    try {
      const response = await saveArea({'areaData': new_areaData, streamName});
      if (response.data.status_code !== 200) {
        sendNotification({ type: 'error', message: response.data.message });
      }else{
        if(response.status === 200) {
          sendNotification({ type: 'success', message: t('Saved area successfully.') });
          // 編集後のarea pointsを即反映
          try {
            const request = indexedDB.open(dbName, 1);
            request.onerror = (e) => console.error('Database error:', (e.target as IDBOpenDBRequest).error);
            request.onsuccess = (e) => {
              const db = (e.target as IDBOpenDBRequest).result;
              const transaction = db.transaction(storeName, 'readwrite');
              const store = transaction.objectStore(storeName);
              const getRequest = store.get('allCameraData');
              getRequest.onerror = (e) => console.error('GetAll request error:', (e.target as IDBOpenDBRequest).error);
              getRequest.onsuccess = () => {
                if (getRequest.result){
                  const allCameraData = getRequest.result.data;
                  const new_allCameraData = allCameraData.map((item: any) => {
                    if (item.camera_name === streamName) {
                      const updatedLineConfiguration = item.line_configuration.map((lineItem: any) => {
                        const matchingArea = new_areaData.find((area: any) => area.areaName === lineItem.id);
                        if (matchingArea) {
                          return { ...lineItem, points: matchingArea.points };
                        } else {
                          return lineItem;
                        }
                      });
                      return { ...item, line_configuration: updatedLineConfiguration };
                    } else {
                      return { ...item };
                    }
                  });
                  store.put({'id': 'allCameraData', 'data': new_allCameraData});
                }
              };
            };
          } catch (error) {
            console.error((error as Error).message);
          }
        } else {
          sendNotification({ type: 'error', message: t('Failed to save.') });
        }
      }
    } catch (error) {
      console.error(error);
      sendNotification({ type: 'error', message: t('Failed to save.') });
    }
    setSaveLoading(false);
    setIsReadOnly(false);
  }, [state, areaData, streamName, sendNotification, t]);
  // --------


  // step other ------------------ 
  // -------- handle area ----------
  const editAreaName = (e: any) => {
    const index = Number(selectedAreaID);
    const new_areaName = e.target.value;
    setIsNameExist(areaData.some((area, idx) => area.name === new_areaName && idx !== index));
    setDefaultAreaName(new_areaName);
    dispatch({
      type: 'RENAME_SET',
      index: index,
      data: {
        name: new_areaName,
      },
    });

    const new_areaData = JSON.parse(JSON.stringify(areaData));
    new_areaData[index].name = new_areaName;
    setAreaData(new_areaData);
  };

  const addArea = useCallback(async () => {
    const id = 'id' + Math.random().toString(16).slice(2);
    const baseName = `${streamName}_new_area`;

    let defaultNewAreaName = `${baseName}`;
    let newNameSuffix = 1;
    const isAreaNameTaken = (area: any) => area.name === defaultNewAreaName;
    while (areaData.some(isAreaNameTaken)) {
      newNameSuffix++;
      defaultNewAreaName = `${baseName}_${newNameSuffix}`;
    }

    const data = {
      'name': defaultNewAreaName,
      'areaName': id,
      'points': [
        { x: 0, y: 0 },
        { x: 500, y: 0 },
        { x: 500, y: 200 },
        { x: 0, y: 200 },
      ],
      'target': [],
      'analysis_type': camAlgorithmType.toLowerCase() === 'vqa' ? 'vqa' : 'count',
      'decisionPoint': detectionPoint[0],
      'probThreshold': 50,
      'minWidth': 1,
      'minHeight': 1,
      'maxWidth': 100,
      'maxHeight': 100,
      'isUseSegArea': 0,
      'segArea': segStatus === 0 ? '利用なし' : segmentation[0].name,
      'segPixelVal': segmentation[0].formula.value,
      'segAreaSize': 1,
      'segThreshold': 50,
      'alertConTime': 60,
      'alertConHoldTime': 360,
      'detectionThreshold': 1,
      'enabled': false,
      'vqa_master_id': vqaMasterData.length===0 ? 0 : vqaMasterData[0].id,
      'schedule_id': schedule.length===0 ? 0 : schedule[0].id,
      'patlite_settings': {enabled: false, activePatlite: null},
      'email_settings': {enabled: false, activeEmails: []}
    };
    dispatch({
      type: 'ADD_SET',
      data
    });

    const new_areaData = JSON.parse(JSON.stringify(areaData));
    new_areaData.push(data);
    selectEditArea((new_areaData.length - 1).toString());
    setAreaData(new_areaData);
    setDefaultAreaName(defaultNewAreaName);
  }, [camAlgorithmType, streamName, detectionPoint, segmentation, areaData, selectEditArea, segStatus, vqaMasterData , schedule]);



  const removeArea = useCallback(async (index) => {
    const areaId = state[Number(selectedAreaID)].areaName;
    try {
      axios.post(BASE_API_URL + '/removeArea', {areaId})
        .then(() => {
          setModalOpen(false);
          setSelectedAreaID('');
          dispatch({
            type: 'REMOVE_SET',
            index,
          });
          sendNotification({ type: 'success', message: t('Remove Area Successfully') });
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .catch((error) => {
          setModalOpen(false);
          console.error(error);
          sendNotification({ type: 'error', message: t('Failed to remove area.') });
        });
    } catch (error) {
      setModalOpen(false);
      console.error(error);
      sendNotification({ type: 'error', message: t('Failed to remove area.') });
    }
  }, [state, selectedAreaID, setModalOpen, sendNotification, t]);

  const addPoint = useCallback(async (index) => {
    if (state[index].points.length >= 50) return;
    setPointNumber(t('Area Sides')+(state[index].points.length+1));
    dispatch({
      type: 'ADD_POINT',
      index,
    });
  }, [state, t]);

  const removePoint = useCallback(async (index) => {
    if (state[index].points.length <= 3) return;
    setPointNumber(t('Area Sides')+(state[index].points.length-1));
    dispatch({
      type: 'REMOVE_POINT',
      index,
    });
  }, [state, t]);


  const getCameraImage = useCallback(async () => {
    if (streamName) {
      try {
        const res: IImageResponse = await axios.get(`${EDGE_API_BASE_URL}/stacks/${streamName}/snapshot?timestamp=${Date.now()}`, { responseType: 'arraybuffer' });
        if (res.status === 200 && res.data) {
          const imgBase64 = 'data:image/jpg;base64,' + Buffer.from(res.data).toString('base64');
          const isImageValid = await isMediaUrlValid(imgBase64, 'img');
          if (isImageValid === true) {
            const img = new Image();
            img.src = imgBase64;
            setImage(imgBase64);
            setImageDetails({
              x: img.naturalWidth,
              y: img.naturalHeight
            });
            setImageLoading(false);
          } else {
            setImage(lang === 'ja' ? AwaitingStreamJp : AwaitingStreamEn);
            setImageLoading(true);
          }
        } else {
          setImage(lang === 'ja' ? AwaitingStreamJp : AwaitingStreamEn);
          setImageLoading(true);
        }
      } catch (err) {
        setImageLoading(true);
        console.error(err);
      }
    }
  }, [streamName, isMediaUrlValid, lang]);

  usePoll(async () => {
    if(imageType === 'LiveImg'){
      getCameraImage();
    }
  }, CAMERA_IMAGE_REFRESH_INTERVAL * 1000);

  const handleCancel = useCallback(() => {
    history.push(`/cameras/camera-details/${streamName}/overview`);
  }, [history, streamName]);

  const getConfirm = useCallback(() => (
    <ConfirmBox>
      <ConfirmText htmlFor='' labelText={t('Are you sure to delete this area')} />
      <ConfirmButtonBox>
        <ButtonFormat autoFocus id='CancelButton' design='secondary' onClick={() => setModalOpen(false)}>{t('Close')}</ButtonFormat>
        <ButtonWithIconFormat tabIndex={0} design='primary' icon='Delete' position='left' onClick={() => removeArea(selectedAreaID)}>{t('Delete')}</ButtonWithIconFormat>
      </ConfirmButtonBox>
    </ConfirmBox>
  ), [setModalOpen, removeArea, selectedAreaID, t]);

  const onClickConfirm = useCallback(() => {
    createModal({
      isCloseEnable: true,
      width: '580px',
      padding: true,
      closeText: 'CLOSE',
      customComponent: getConfirm()
    });
  }, [createModal, getConfirm]);

  const SaveEditArea = useCallback(() => {
    const indexToUpdate = state.findIndex(item => item.name === state_edit[0].name);
    const new_state = state.map((item, index) =>
      index === indexToUpdate ? state_edit[0] : item
    );
    dispatch({
      type: 'LOAD',
      state: new_state,
    });
    setShowEditArea(false);
  }, [state, state_edit]);

  
  const CloseEditArea = useCallback(() => {
    const index = Number(selectedAreaID);
    const new_state = JSON.parse(JSON.stringify(state[index]));
    dispatch_edit({
      type: 'LOAD',
      state: [new_state],
    });
    setShowEditArea(false);
  }, [state, selectedAreaID]);

  const OpenEditArea = useCallback(() => {
    setShowEditArea(true);
  }, []);
  useEffect(()=>{
    if (showEditArea){
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [showEditArea]);

  const handleTimeUnit = (e:any, type:any) => {
    const obj = {...timeUnit};
    if(type === 'unit1'){
      obj.unit1 = e;
    } else if(type === 'unit2'){
      obj.unit2 = e;
    }
    setTimeUnit(obj);
  };



  
  /*const fetchAlgorithmType = useCallback(async () => {
    try {
      const res = await getAlgorithmType(streamName);
      if (res.data) {
        const mapping: any = {
          'tcp://dealer:6789': 'CROWD',
          'tcp://dealer_yolo:6809': 'YOLO',
          'tcp://image_sink:6801': 'VQA',
          'tcp://dealer_river:6799': 'Segmentation'
        };
        
        const destinations = res.data.data.services.fog_broadcaster1.destinations;
        
        if (destinations) {
          const algorithmTypes = destinations.map((url: any) => {
            if (url in mapping) {
              return mapping[url];
            }
            return null;
          }).filter(Boolean);  // remove null values

          //setCamAlgorithmType(algorithmTypes.join(', '));
          console.log(algorithmTypes.join(', '));
          //setAnalysisType(algorithmTypes[0]);
          console.log(algorithmTypes[0]);
          //setVqaStatus(algorithmTypes.includes('VQA') ? 1 : 0);
          console.log(algorithmTypes.includes('VQA') ? 1 : 0);
        }
      }
    } catch (error){
      console.error(error);
    }
  },[streamName]);
  useEffect(() => {
    fetchAlgorithmType();
  },[fetchAlgorithmType]);*/
 

  useEffect(() => {
    const selectedItem = vqaMasterData.find((item: any) => item.id === Number(vqaMasterID));
    if (selectedItem){
      setSelectedModel(vqaMasterID ? selectedItem.vqa_model : vqaMasterData[0].vqa_model);
    }
  },[vqaMasterID, vqaMasterData]);

  const uniqueModels:any = [];
  const modelSet = new Set();
  vqaMasterData.forEach((item: any) => {
    if (!modelSet.has(item.vqa_model)) {
      modelSet.add(item.vqa_model);
      uniqueModels.push(item);
    }
  });

  const handleScheduleData = useCallback(async () => {
    try {
      if(scheduleID){
        const open_time_window = schedule.find((val:any) => val.id === Number(scheduleID)).schedule.open_time_window;
        setOpenTimeWindow(open_time_window);
        const open_day = schedule.find((val:any) => val.id === Number(scheduleID)).schedule.open_day;
        setOpenDay(open_day);
      }
    } catch (error){
      console.error(error);
    }
  }, [scheduleID, schedule]);

  useEffect(() => {
    handleScheduleData();
  },[handleScheduleData]);
    

  return (
    <Content>
      <Header>
        <PageHeaderComponent>
          <PageHeader
            areaTitle={t('Configuration')}
            icon='Analyse'
            updateDocTitle={false}
            title={streamName}
          />
          <StyledLabelAlgorithm htmlFor='' labelText=''>{t('Algorithm Type')}</StyledLabelAlgorithm>
          <StyledAlgorithmText>{camAlgorithmType.toUpperCase()}</StyledAlgorithmText>
        </PageHeaderComponent>
        <ButtonContainer>
          <CancelButton
            design='secondary'
            size='small'
            onClick={handleCancel}
          >
            {t('Cancel')}
          </CancelButton>
          <ButtonWithLoading
            design='primary'
            loading={saveLoading}
            disabled={
              isReadOnly
              || saveDisabled
              || isNameExist
              || selectedAreaID === ''
              || state.length === 0
              || ((areaData.filter(c => c.analysis_type.toLowerCase() === 'vqa').length === 0) && areaData.filter(c => c.analysis_type.toLowerCase() !== 'vqa').length === 0)
              || areaData.filter(c => c.analysis_type.toLowerCase() === 'count' && c.target.length === 0).length > 0
            }
            size='small'
            onClick={saveAreas}
          >
            {t('Save Changes')}
          </ButtonWithLoading>
          <ButtonWithIcon icon='Edit' size='small' position='left' design='secondary' onClick={() => history.push(`/edit-camera?camera-name=${streamName}`)}>{t('Edit Camera')}</ButtonWithIcon>
        </ButtonContainer>
      </Header>
      <MainContent>
        <AlertContainer>
          {camAlgorithmType ==='' && 
            <AlertBar
              message={t('Analysis algorithm has not been set. Please add it from camera settings.')}
              type='error'
            />}
          {isNameExist && 
            <AlertBar
              message={t('Duplicate area name. please confirm.')}
              type='error'
            />}
          {selectedAreaID ? (analysisType!== 'VQA' && areaData[Number(selectedAreaID)].target.length === 0 && areaData[Number(selectedAreaID)].analysis_type.toLowerCase() === 'count') ?
            <AlertBar 
              message={`${t('Unanalyzable Area')}: ${areaData[Number(selectedAreaID)].name} ${t('Analysis target has not been set.')}`}
              type='error'
            /> : '' : ''}   
          {errAreaList.map((item: any, index: number) => {
            return(
              <AlertBar
                key={index}
                message={`${t('Unanalyzable Area')}: [${item}] ${t('Please check the analysis settings from the camera console')}`}
                type='error'
              />);
          })}
        </AlertContainer>
        <LineSettingsContainer>
          <h5>{t('Area Configuration')}</h5>
          <LineSelectFieldContainer>
            <Icon icon='MetaCategories' size={16} color='dimmed' />
            <StyledSelectField
              changeCallback={(e)=>selectEditArea(e)}
              disabled={isReadOnly}
              isCompact
              value={selectedAreaID ? Number(selectedAreaID) : ''}
              placeholder={t('Choose an area...')}
            >
              {
                state.map((item: any, index: any) => {
                  return (
                    <option key={index} value={index}>
                      {item.name}
                    </option>
                  );
                })
              }
            </StyledSelectField>
            <InputAndButtonContainer gap='0 10px'>
              <ButtonWithIcon
                icon='Add'
                position='left'
                size='small'
                design='secondary'
                onClick={addArea}
                disabled={state.length === 20 || camAlgorithmType ==='' ||isReadOnly}
              >
                {t('Add Area')}
              </ButtonWithIcon>
              <ButtonWithIcon
                icon='ActionRemove'
                position='left'
                size='small'
                design='secondary'
                onClick={onClickConfirm}
                disabled={selectedAreaID === '' || state.length === 0 || isReadOnly}
              >
                {t('Remove Area')}
              </ButtonWithIcon>
              <ButtonWithIcon
                icon='Edit'
                position='left'
                size='small'
                design='secondary'
                onClick={() => OpenEditArea()}
                disabled={selectedAreaID === '' || state.length === 0 || isReadOnly}
              >
                {t('Edit Area')}
              </ButtonWithIcon>
            </InputAndButtonContainer>
          </LineSelectFieldContainer>
          <LineUIContainer>
            {(selectedAreaID !== '') && (
              <div>
                <LineUILeftPanel>
                  <SidePaddingDiv>
                    <StyledSmallInputWithLabel
                      fieldState='default'
                      label={t('Area Name')}
                      name='Area Name'
                      length='200px'
                      maxLength={24}
                      disabled={isReadOnly}
                      value={defaultAreaName ? defaultAreaName : state[Number(selectedAreaID)].name}
                      onChange={(e) => editAreaName(e)}
                    />
                    <LabelWithMargin
                      htmlFor='pointNumber'
                      labelText={pointNumber}
                      style={{ marginTop: '10px' }}
                    />
                    <ButtonWithIcon
                      icon='Add'
                      position='left'
                      size='xsmall'
                      design='secondary'
                      onClick={() => addPoint(selectedAreaID)}
                      disabled={selectedAreaID === '' || state.length === 20 || isReadOnly}
                    >
                      {t('Add')}
                    </ButtonWithIcon>
                    <ButtonWithIcon
                      icon='ActionRemove'
                      position='left'
                      size='xsmall'
                      design='secondary'
                      onClick={() => removePoint(selectedAreaID)}
                      disabled={selectedAreaID === '' || state.length === 20 || isReadOnly}
                    >
                      {t('Remove')}
                    </ButtonWithIcon>
                    <br />
                    <br />
                    <Switch
                      checked={isAnalysisEnabled}
                      labelText={t(isAnalysisEnabled ? 'Enabled' : 'Disabled')}
                      // labelText={t('Enable Detection')}
                      leftTheme='off'
                      onChangeCallback={(e) => handleCameraEnable(e)}
                      rightTheme='on'
                      state={isReadOnly || !selectedAreaID? 'disabled' : 'default'}
                    />
               
                  </SidePaddingDiv>
                </LineUILeftPanel>









                <LineUIRightPanel>
                  <SidePaddingDiv>
                    <InputAndButtonContainer gap='0 14px'>
                      <div>
                        <LabelWithMargin
                          htmlFor='analysisType'
                          labelText={t('Analysis Type')}
                        />
                        <StyledSelectField
                          changeCallback={(e) => { handleAnalysisType(e); }}
                          disabled={isReadOnly}
                          isCompact
                          value={analysisType}
                          placeholder={t('Choose type...')}
                          style={{ width: '120px' }}
                        >
                          {camAlgorithmType.includes('CROWD') || camAlgorithmType.includes('YOLO') ? <option key={1} value='Count'>Count</option> : ''}
                          {segStatus === 0 ? '' : <option key={2} value='Ratio'>Ratio</option>}
                          {vqaStatus === 0 ? '' : <option key={3} value='vqa'>VQA</option>}
                        </StyledSelectField>
                      </div>










                      {(analysisType.toLowerCase() === 'count') && (
                        <>
                          <div>
                            <LabelWithMargin
                              htmlFor='decisionPoint'
                              labelText={t('Decision Point')}
                            />
                            <StyledSelectField
                              changeCallback={(e) => { handleCountConfig(e, 'setDecisionPoint'); }}
                              placeholder='Choose an option...'
                              // disabled={isReadOnly}
                              isCompact
                              value={decisionPoint}
                              style={{ width: '150px' }}
                            >
                              {
                                detectionPoint.map((item: any, index: any) => {
                                  return (
                                    <option key={index} value={item}>
                                      {JSON.parse(item).name}
                                    </option>
                                  );
                                })
                              }
                            </StyledSelectField>
                          </div>
                          <div style={{ minHeight: '60px' }}>
                            <TargetAndEditContainer>
                              <LabelWithMargin
                                htmlFor='analysisTargets'
                                labelText={t('Analysis Targets')}
                              />
                              <EditButton
                                buttonIcon='NoIcon'
                                buttonText='Edit'
                                hasOptionsFilter
                                list={objectTarget}
                                loadingText='ローディング...'
                                maxDisplayedItems={6}
                                onSelect={(e: any) => { handleCountConfig(e, 'setSelectedObjectTarget'); }}
                                optionType='checkbox'
                                searchPlaceholder='Filter targets...'
                                searchResultText='Showing [VISIBLE] of [TOTAL]'
                                selected={selectedObjectTarget}
                              />
                            </TargetAndEditContainer>
                            <div>
                              {selectedObjectTarget ?
                                selectedObjectTarget.map((item: any, index: any) => {
                                  return (
                                    <ButtonWithIcon
                                      icon='Analyse'
                                      position='left'
                                      size='xsmall'
                                      design='secondary'
                                      key={index}
                                      value={item.value}
                                      disabled={isReadOnly}
                                    >
                                      {item.text}
                                    </ButtonWithIcon>
                                  );
                                })
                                : ''}
                            </div>
                          </div>
                        </>
                      )}
                    </InputAndButtonContainer>

                    {(analysisType.toLowerCase() === 'count') && (
                      <>
                        {segStatus !== 0 ?
                          <>
                            <h5>{t('Decision Settings')}</h5>
                            <InputAndButtonContainer gap='0 14px'>
                              <div>
                                <LabelWithMargin
                                  htmlFor='segmentation'
                                  labelText={t('Segmentation')}
                                />
                                <StyledSelectField
                                  changeCallback={(e) => { handleCountConfig(e, 'selectSegArea'); }}
                                  // disabled={isReadOnly}
                                  isCompact
                                  value={segArea}
                                  placeholder='Choose segmentation...'
                                  style={{ width: '150px' }}
                                >
                                  <option value='利用なし'>
                                    {t('Not use')}
                                  </option>
                                  {
                                    segmentation.map((item: any, index: any) => {
                                      return (
                                        <option key={index} value={item.name}>
                                          {item.name}
                                        </option>
                                      );
                                    })
                                  }
                                </StyledSelectField>
                              </div>
                              {(segArea !== '利用なし') && (
                                <>
                                  <StyledSmallInputWithLabel
                                    fieldState='default'
                                    label={t('Decision Size')}
                                    name='decisionSize'
                                    length='90px'
                                    maxLength={24}
                                    disabled={isReadOnly}
                                    value={segAreaSize}
                                    onChange={(e) => { handleCountConfig(e.target.value, 'setSegAreaSize'); }}
                                  />
                                  <StyledSmallInput2
                                    fieldState='default'
                                    name='areaThreshold'
                                    type='number'
                                    min={1}
                                    max={100}
                                    disabled={isReadOnly}
                                    length='200px'
                                    label={t('Area Threshold')}
                                    unit='%'
                                    value={segThreshold}
                                    onChange={(e) => { handleCountConfig(e.target.value, 'setSegThreshold'); }}
                                  />
                                </>
                              )}
                            </InputAndButtonContainer>
                          </> : ''}

                        <DividerWithMargin />
                        <InputAndButtonContainer gap='0 24px'>
                          <StyledSmallInput2
                            fieldState='default'
                            name='countThreshold'
                            type='number'
                            min={1}
                            max={100}
                            disabled={isReadOnly}
                            length='250px'
                            label={t('Count Threshold')}
                            unit={t('unit')}
                            value={detectionThreshold}
                            onChange={(e) => { handleCountConfig(e.target.value, 'setDetectionThreshold'); }}
                          />
                          <StyledSmallInputWithLabel
                            fieldState='default'
                            name='detectionProbability'
                            type='number'
                            min={0}
                            max={100}
                            disabled={isReadOnly}
                            length='150px'
                            label={t('Detection Probability')}
                            unit='%'
                            value={probThreshold}
                            onChange={(e) => { handleCountConfig(e.target.value, 'setProbThreshold'); }}
                          />
                        </InputAndButtonContainer>
                        <DividerWithMargin />
                        <InputAndButtonContainer gap='0 14px'>
                          <StyledSmallInput2
                            fieldState='default'
                            name='minWidth'
                            type='number'
                            min={0}
                            // max={10000}
                            disabled={isReadOnly}
                            length='120px'
                            label={t('Minimum Width')}
                            unit='px'
                            value={minWidth}
                            onChange={(e) => { handleCountConfig(e.target.value, 'setMinWidth'); }}
                          />
                          <StyledSmallInput2
                            fieldState='default'
                            name='maxWidth'
                            type='number'
                            min={0}
                            // max={10000}
                            disabled={isReadOnly}
                            length='120px'
                            label={t('Maximum Width')}
                            unit='px'
                            value={maxWidth}
                            onChange={(e) => { handleCountConfig(e.target.value, 'setMaxWidth'); }}
                          />
                          <StyledSmallInput2
                            fieldState='default'
                            name='minHeight'
                            type='number'
                            min={0}
                            // max={10000}
                            disabled={isReadOnly}
                            length='120px'
                            label={t('Minimum Height')}
                            unit='px'
                            value={minHeight}
                            onChange={(e) => { handleCountConfig(e.target.value, 'setMinHeight'); }}
                          />
                          <StyledSmallInput2
                            fieldState='default'
                            name='maxHeight'
                            type='number'
                            min={0}
                            // max={10000}
                            disabled={isReadOnly}
                            length='120px'
                            label={t('Maximum Height')}
                            unit='px'
                            value={maxHeight}
                            onChange={(e) => { handleCountConfig(e.target.value, 'setMaxHeight'); }}
                          />
                        </InputAndButtonContainer>
                        <DividerWithMargin />
                        <h5>{t('Alert Settings')}</h5>
                        <InputAndButtonContainer gap='0 14px'>
                          <StyledSmallInputWithLabel2
                            fieldState='default'
                            label={t('Duration Trigger Time')}
                            name='alertConTime'
                            length='100px'
                            disabled={isReadOnly}
                            value={alertConTime}
                            type='number'
                            min={0}
                            max={timeUnit.unit1 === 'sec' ? 86400 : timeUnit.unit1 === 'min' ? 1440 : 24}
                            onChange={(e) => { handleCountConfig(e.target.value, 'setAlertConTime'); }}
                          />
                          <div style={{marginTop: '28px'}}>
                            <StyledSelectField
                              changeCallback={(e) => { handleTimeUnit(e, 'unit1'); }}
                              disabled={isReadOnly}
                              isCompact
                              value={timeUnit.unit1}
                              placeholder={t('Choose type...')}
                              style={{ width: '80px' }}
                            >
                              <option key={1} value='hour'>
                                {t('hour')}
                              </option>
                              <option key={2} value='min'>
                                {t('min')}
                              </option>
                              <option key={3} value='sec'>
                                {t('sec')}
                              </option>
                            </StyledSelectField>
                          </div>
                          <StyledSmallInputWithLabel2
                            fieldState='default'
                            label={t('Alert Send Cooldown')}
                            name='alertResTime'
                            length='100px'
                            maxLength={24}
                            disabled={isReadOnly}
                            value={alertConHoldTime}
                            type='number'
                            min={0}
                            max={timeUnit.unit2 === 'sec' ? 86400 : timeUnit.unit2 === 'min' ? 1440 : 24}
                            onChange={(e) => { handleCountConfig(e.target.value, 'setAlertConHoldTime'); }}
                          />
                          <div style={{marginTop: '28px'}}>
                            <StyledSelectField
                              changeCallback={(e) => { handleTimeUnit(e, 'unit2'); }}
                              disabled={isReadOnly}
                              isCompact
                              value={timeUnit.unit2}
                              placeholder={t('Choose type...')}
                              style={{ width: '80px' }}
                            >
                              <option key={1} value='hour'>
                                {t('hour')}
                              </option>
                              <option key={2} value='min'>
                                {t('min')}
                              </option>
                              <option key={3} value='sec'>
                                {t('sec')}
                              </option>
                            </StyledSelectField>
                          </div>
                        </InputAndButtonContainer>
                      </>
                    )}











                    {(analysisType.toLowerCase() === 'ratio') && (
                      <>
                        <h5>{t('Decision Settings')}</h5>
                        <InputAndButtonContainer gap='0 14px'>
                          <div>
                            <LabelWithMargin
                              htmlFor='segmentation'
                              labelText={t('Segmentation')}
                            />
                            <StyledSelectField
                              changeCallback={(e) => { handleRatioConfig(e, 'selectSegArea'); }}
                              // disabled={isReadOnly}
                              isCompact
                              value={segArea}
                              placeholder='Choose segmentation...'
                              style={{ width: '150px' }}
                            >
                              <option value='利用なし'>
                                {t('Not use')}
                              </option>
                              {
                                segmentation.map((item: any, index: any) => {
                                  return (
                                    <option key={index} value={item.name}>
                                      {item.name}
                                    </option>
                                  );
                                })
                              }
                            </StyledSelectField>
                          </div>
                          <StyledSmallInput2
                            fieldState='default'
                            name='areaThreshold'
                            type='number'
                            min={1}
                            max={100}
                            disabled={isReadOnly}
                            length='120px'
                            label={t('Area Threshold')}
                            unit='%'
                            value={segThreshold}
                            onChange={(e) => { handleRatioConfig(e.target.value, 'setSegThreshold'); }}
                          />
                        </InputAndButtonContainer>
                        <h5>{t('Alert Settings')}</h5>
                        <InputAndButtonContainer gap='0 14px'>
                          <StyledSmallInputWithLabel2
                            fieldState='default'
                            label={t('Duration Trigger Time')}
                            name='alertConTime'
                            length='100px'
                            disabled={isReadOnly}
                            value={alertConTime}
                            type='number'
                            min={0}
                            max={timeUnit.unit1 === 'sec' ? 86400 : timeUnit.unit1 === 'min' ? 1440 : 24}
                            onChange={(e) => { handleCountConfig(e.target.value, 'setAlertConTime'); }}
                          />
                          <div style={{marginTop: '28px'}}>
                            <StyledSelectField
                              changeCallback={(e) => { handleTimeUnit(e, 'unit1'); }}
                              disabled={isReadOnly}
                              isCompact
                              value={timeUnit.unit1}
                              placeholder={t('Choose type...')}
                              style={{ width: '80px' }}
                            >
                              <option key={1} value='hour'>
                                {t('hour')}
                              </option>
                              <option key={2} value='min'>
                                {t('min')}
                              </option>
                              <option key={3} value='sec'>
                                {t('sec')}
                              </option>
                            </StyledSelectField>
                          </div>
                          <StyledSmallInputWithLabel2
                            fieldState='default'
                            label={t('Alert Send Cooldown')}
                            name='alertResTime'
                            length='100px'
                            maxLength={24}
                            disabled={isReadOnly}
                            value={alertConHoldTime}
                            type='number'
                            min={0}
                            max={timeUnit.unit2 === 'sec' ? 86400 : timeUnit.unit2 === 'min' ? 1440 : 24}
                            onChange={(e) => { handleCountConfig(e.target.value, 'setAlertConHoldTime'); }}
                          />
                          <div style={{marginTop: '28px'}}>
                            <StyledSelectField
                              changeCallback={(e) => { handleTimeUnit(e, 'unit2'); }}
                              disabled={isReadOnly}
                              isCompact
                              value={timeUnit.unit2}
                              placeholder={t('Choose type...')}
                              style={{ width: '80px' }}
                            >
                              <option key={1} value='hour'>
                                {t('hour')}
                              </option>
                              <option key={2} value='min'>
                                {t('min')}
                              </option>
                              <option key={3} value='sec'>
                                {t('sec')}
                              </option>
                            </StyledSelectField>
                          </div>
                        </InputAndButtonContainer>
                      </>
                    )}











                    {(analysisType?.toLowerCase() === 'vqa') && (
                      <VQAContainer>
                        <h5>{t('Decision Settings')}</h5>
                        <WrapTextField>
                          <SelectField
                            name='Model'
                            value={selectedModel}
                            changeCallback={(e: any) => handleVqamodel(e)}
                            label={{
                              htmlFor: 'fix_select',
                              isSameRow: true,
                              text: t('Model')
                            }}
                          >
                            {
                              uniqueModels.map((item: any, index: any) => {
                                return (
                                  <option key={index} value={item.vqa_model}>
                                    {item.vqa_model}
                                  </option>
                                );
                              })
                            }
                          </SelectField>

                          <SelectField
                            name='name'
                            changeCallback={(e: any) => { handleVqaConfig(e, 'vqaMaster'); }}
                            value={vqaMasterID}
                            label={{
                              htmlFor: 'fix_select',
                              isSameRow: true,
                              text: t('VQA Set Name')
                            }}
                          >
                            {
                              vqaMasterData.filter((item: any) => selectedModel==='' || item.vqa_model === selectedModel).map((item: any, index: any) => {
                                return (
                                  <option key={index} value={item.id}>
                                    {item.vqa_set_name}_{item.vqa_model}
                                  </option>
                                );
                              })
                            }
                          </SelectField>
                   
                          
                          <TextFieldContainer>
                            <p>{t('Parameters')}</p>
                            <TextAreaField
                              fieldState='default'
                              label=''
                              name='parameters'
                              placeholder='Parameters'
                              value={JSON.stringify(vqaMasterData.find((item: any) => item.id === Number(vqaMasterID))?.parameter)}
                              disabled
                              style={{ backgroundColor: 'hsl(0, 0%, 79%)', color: 'white'}}
                            />
                          </TextFieldContainer>

                          <TextFieldContainer>
                            <p>{t('Trigger keyword')}</p>
                            <TextAreaField
                              fieldState='default'
                              label=''
                              name='trigger_keyword'
                              placeholder='Trigger keyword'
                              value={vqaMasterData.find((item: any) => item.id === Number(vqaMasterID))?.trigger_keyword}
                              disabled
                              style={{ backgroundColor: 'hsl(0, 0%, 79%)', color: 'white'}}
                            />
                          </TextFieldContainer>  

                          <TextFieldContainer>
                            <p>{t('Schedule Type')}</p>
                            <SelectAndScheduleContainer>
                              <SelectField
                                name='schedule'
                                changeCallback={(e: any) => { handleVqaConfig(e, 'schedule'); }}
                                value={scheduleID}
                              >                                      
                                {
                                  schedule.map((item: any, index: any) => {
                                    return (
                                      <option key={index} value={item.id}>
                                        {item.name}
                                      </option>
                                    );
                                  })
                                }
                              </SelectField>
                              {openTimeWindow.length > 0 ?
                                <ScheduleContainer>
                                  {t('Open Time Window')}: 
                                  {
                                    openTimeWindow.map((item: any, index: any) => {
                                      return (    
                                        <div key={index}>{t(item.day_of_week)} {item.start_time}~{item.end_time}</div>
                                      );
                                    })
                                  }
                                </ScheduleContainer>
                                : ''}
                              
                              {openDay.length > 0 ?
                                <ScheduleContainer>
                                  {t('Schedule Exceptions')}: 
                                  {
                                    openDay.map((item: any, index: any) => {
                                      return (    
                                        <div key={index}>{dayjs(item.date, 'MMDD').format(t('MM-DD'))} {item.start_time}~{item.end_time}</div>
                                      );
                                    })
                                  }
                                </ScheduleContainer>
                                : ''}
                            </SelectAndScheduleContainer>
                          
                          </TextFieldContainer>

                          <ContinueTimeContainer>
                            <InputAndButtonContainer gap='0 14px'>
                              <StyledSmallInputWithLabel2
                                fieldState='default'
                                label={t('Duration Trigger Time')}
                                name='alertConTime'
                                length='100px'
                                disabled={isReadOnly}
                                value={alertConTime}
                                type='number'
                                min={0}
                                max={timeUnit.unit1 === 'sec' ? 86400 : timeUnit.unit1 === 'min' ? 1440 : 24}
                                onChange={(e) => { handleVqaConfig(e.target.value, 'setAlertConTime'); }}
                              />
                              <div style={{marginTop: '28px'}}>
                                <StyledSelectField
                                  changeCallback={(e) => { handleTimeUnit(e, 'unit1'); }}
                                  disabled={isReadOnly}
                                  isCompact
                                  value={timeUnit.unit1}
                                  placeholder={t('Choose type...')}
                                  style={{ width: '80px' }}
                                >
                                  <option key={1} value='hour'>
                                    {t('hour')}
                                  </option>
                                  <option key={2} value='min'>
                                    {t('min')}
                                  </option>
                                  <option key={3} value='sec'>
                                    {t('sec')}
                                  </option>
                                </StyledSelectField>
                              </div>
                              <StyledSmallInputWithLabel2
                                fieldState='default'
                                label={t('Alert Send Cooldown')}
                                name='alertResTime'
                                length='100px'
                                maxLength={24}
                                disabled={isReadOnly}
                                value={alertConHoldTime}
                                type='number'
                                min={0}
                                max={timeUnit.unit2 === 'sec' ? 86400 : timeUnit.unit2 === 'min' ? 1440 : 24}
                                onChange={(e) => { handleVqaConfig(e.target.value, 'setAlertConHoldTime'); }}
                              />
                              <div style={{marginTop: '28px'}}>
                                <StyledSelectField
                                  changeCallback={(e) => { handleTimeUnit(e, 'unit2'); }}
                                  disabled={isReadOnly}
                                  isCompact
                                  value={timeUnit.unit2}
                                  placeholder={t('Choose type...')}
                                  style={{ width: '80px' }}
                                >
                                  <option key={1} value='hour'>
                                    {t('hour')}
                                  </option>
                                  <option key={2} value='min'>
                                    {t('min')}
                                  </option>
                                  <option key={3} value='sec'>
                                    {t('sec')}
                                  </option>
                                </StyledSelectField>
                              </div>
                            </InputAndButtonContainer>
                          </ContinueTimeContainer>
                        </WrapTextField>
                      </VQAContainer>
                    )}
                    <DividerWithMargin />
                    <>
                      <h5>{t('Alert Settings')}</h5>
                      <LeftPanel>
                        <div>
                          <LabelWithMargin
                            htmlFor='patlite_enable'
                            labelText={t('Patlite Enabled')}
                          />
                          <Switch
                            checked={patliteEnable}
                            leftTheme='off'
                            onChangeCallback={(e) => handleAlertConfig(e, 'setPatliteEnable')}
                            rightTheme='on'
                          //   state={isReadOnly ? 'disabled' : 'default'}
                          />
                        </div>
                        <div>
                          <LabelWithMargin
                            htmlFor='email_enable'
                            labelText={t('Email Enabled')}
                          />
                          <Switch
                            checked={emailEnable}
                            leftTheme='off'
                            onChangeCallback={(e) => handleAlertConfig(e, 'setEmailEnable')}
                            rightTheme='on'
                          //   state={isReadOnly ? 'disabled' : 'default'}
                          />
                        </div>
                      </LeftPanel>
                      <RightPanel>
                        <div style={{ width: '150px' }}>
                          <LabelWithMargin
                            htmlFor='active_patlite'
                            labelText={t('Patlite Selection')}
                          />
                          <StyledSelectField
                            changeCallback={(e) => handleAlertConfig(e, 'setActivePatlite')}
                            disabled={isReadOnly}
                            isCompact
                            value={activePatlite ? Number(activePatlite) : ''}
                            placeholder='Choose Patlite...'
                          >
                            {
                              alertData.patlites.map((item: any, index: any) => {
                                return (
                                  <option key={index} value={item.id}>
                                    {item.name}
                                  </option>
                                );
                              })
                            }
                          </StyledSelectField>
                        </div>
                        {/* <div>
                          <LabelWithMargin
                            htmlFor='active_patlites'
                            labelText={t('Active Patlites')}
                          />
                          <FilterDropdown
                            buttonIcon='MetaCategories'
                            buttonText={
                              activePatlite
                                ? activePatlite.length > 5
                                  ? alertData.patlites.filter((x: any)=> activePatlite.includes(x.value)).map((x:any)=> x.text).slice(0, 3).join('，') + ' ...'
                                  : alertData.patlites.filter((x: any)=> activePatlite.includes(x.value)).map((x:any)=> x.text).join('，')
                                : ''
                            }
                            list={alertData.patlites}
                            loadingText='ローディング...'
                            maxDisplayedItems={6}
                            onSelect={(e) => handleAlertConfig(e, 'setActivePatlite')}
                            optionType='checkbox'
                            selected={alertData.patlites.filter((x: any)=> activePatlite.includes(x.value))}
                          />
                        </div> */}
                        <div>
                          <LabelWithMargin
                            htmlFor='active_emails'
                            labelText={t('Emails Selection')}
                          />
                          <FilterDropdown
                            buttonIcon='MetaCategories'
                            buttonText={
                              activeEmails
                                ? activeEmails.length > 5
                                  ? alertData.emails.filter((x: any)=> activeEmails.includes(x.value)).map((x:any)=> x.text).slice(0, 3).join('，') + ' ...'
                                  : alertData.emails.filter((x: any)=> activeEmails.includes(x.value)).map((x:any)=> x.text).join('，')
                                : ''
                            }
                            list={alertData.emails}
                            loadingText='ローディング...'
                            maxDisplayedItems={6}
                            onSelect={(e) => handleAlertConfig(e, 'setActiveEmail')}
                            optionType='checkbox'
                            selected={alertData.emails.filter((x: any)=> activeEmails.includes(x.value))}
                          />
                        </div>
                      </RightPanel>
                      {/* multiple select for patlites  */}
                      {/* <InputAndButtonContainer gap='0 14px'>
                        <div>
                          <LabelWithMargin
                            htmlFor='patlite_enable'
                            labelText={t('Alert Patlite Enabled')}
                          />
                          <Switch
                            checked={patliteEnable}
                            leftTheme='off'
                            onChangeCallback={(e) => handleAlertConfig(e, 'setPatliteEnable')}
                            rightTheme='on'
                          //   state={isReadOnly ? 'disabled' : 'default'}
                          />
                        </div>
                        <div style={{ marginTop: '9px' }}>
                          <LabelWithMargin
                            htmlFor='active_patlites'
                            labelText={t('Active Patlites')}
                          />
                          <FilterDropdown
                            buttonIcon='MetaCategories'
                            buttonText={
                              activePatlite
                                ? activePatlite.length > 5
                                  ? alertData.patlites.filter((x: any)=> activePatlite.includes(x.value)).map((x:any)=> x.text).slice(0, 3).join('，') + ' ...'
                                  : alertData.patlites.filter((x: any)=> activePatlite.includes(x.value)).map((x:any)=> x.text).join('，')
                                : ''
                            }
                            list={alertData.patlites}
                            loadingText='ローディング...'
                            maxDisplayedItems={6}
                            onSelect={(e) => handleAlertConfig(e, 'setActivePatlite')}
                            optionType='checkbox'
                            selected={alertData.patlites.filter((x: any)=> activePatlite.includes(x.value))}
                          />
                        </div>
                      </InputAndButtonContainer>
                      <InputAndButtonContainer gap='0 14px'>
                        <div>
                          <LabelWithMargin
                            htmlFor='email_enable'
                            labelText={t('Alert Email Enabled')}
                          />
                          <Switch
                            checked={emailEnable}
                            leftTheme='off'
                            onChangeCallback={(e) => handleAlertConfig(e, 'setEmailEnable')}
                            rightTheme='on'
                          //   state={isReadOnly ? 'disabled' : 'default'}
                          />
                        </div>
                        <div style={{ marginTop: '9px' }}>
                          <LabelWithMargin
                            htmlFor='active_emails'
                            labelText={t('Active Emails')}
                          />
                          <FilterDropdown
                            buttonIcon='MetaCategories'
                            buttonText={
                              activeEmails
                                ? activeEmails.length > 5
                                  ? alertData.emails.filter((x: any)=> activeEmails.includes(x.value)).map((x:any)=> x.text).slice(0, 3).join('，') + ' ...'
                                  : alertData.emails.filter((x: any)=> activeEmails.includes(x.value)).map((x:any)=> x.text).join('，')
                                : ''
                            }
                            list={alertData.emails}
                            loadingText='ローディング...'
                            maxDisplayedItems={6}
                            onSelect={(e) => handleAlertConfig(e, 'setActiveEmail')}
                            optionType='checkbox'
                            selected={alertData.emails.filter((x: any)=> activeEmails.includes(x.value))}
                          />
                        </div>
                      </InputAndButtonContainer> */}
                    </>
                  </SidePaddingDiv>
                </LineUIRightPanel>
              </div>
            )}
            {(selectedAreaID && analysisType !== 'vqa')?
              <>
                <DividerWithMargin />
                <div style={{ width: '150px', marginLeft: '20px' }}>
                  <StyledSelectField
                    label={t('Select Image Type')}
                    name='Select Image Type'
                    changeCallback={handleImageType}
                    value={imageType}
                    defaultValue='originalImg'
                    disabled={false}
                    isCompact
                  > 
                    <option value='LiveImg'>{t('Camare Image')}</option>
                    <option value='originalImg'>{t('Original Image')}</option>
                    <option value='resultImg'>{t('Result Image')}</option>
                  </StyledSelectField>
                </div>
              </> : ''}



            <LineUIBottomPanel>
              <SidePaddingDiv>
                <LineUIImageWrapper isReadOnly={isReadOnly} id='lineui-id'>
                  <LineSetContext.Provider value={{ state, dispatch }}>
                    {imageLoading ?
                      <SpinnerContainer>
                        <Spinner size='large' styling='primary' />
                      </SpinnerContainer>
                      :
                      <div>
                        <LineUI
                          options={{
                            showSetIndex: false,
                            showPoint: true,
                            showMoveHandle: false,
                            showPointHandle: true,
                            setIndexOffset: 0,
                            boundaryOffset: Math.round(imageDetails.x * 0.5 / 100),
                            fixedImgDimensions: imageDetails
                          }}
                          src={imageType === 'LiveImg' ? image : image2}
                        />
                      </div>}

                  </LineSetContext.Provider>
                </LineUIImageWrapper>
              </SidePaddingDiv>
            </LineUIBottomPanel>


            {showEditArea &&
              <BoxModal
                closeText={t('CLOSE')}
                isOpen={showEditArea}
                onDismiss={() => CloseEditArea()}
                customeComponent={
                  <ConfirmBox>
                    <ConfirmText htmlFor='' labelText={t('Edit Area')} />
                    <LineUIImageWrapper isReadOnly={false}>
                      <LineSetContext.Provider value={{ 'state': state_edit, 'dispatch': dispatch_edit }}>
                        <LineUI
                          options={{
                            showSetIndex: false,
                            showPoint: true,
                            showMoveHandle: false,
                            showPointHandle: true,
                            setIndexOffset: 0,
                            boundaryOffset: Math.round(imageDetails.x * 0.5 / 100),
                            fixedImgDimensions: imageDetails
                          }}
                          src={imageType === 'LiveImg' ? image : image2}
                        />
                      </LineSetContext.Provider>
                    </LineUIImageWrapper>
                    <ConfirmButtonBox>
                      <ButtonFormat autoFocus id='CancelButton' design='secondary' onClick={() => CloseEditArea()}>{t('Close')}</ButtonFormat>
                      <ButtonFormat autoFocus id='SaveAreaButton' design='primary' onClick={() => SaveEditArea()}>{t('Save')}</ButtonFormat>
                    </ConfirmButtonBox>
                  </ConfirmBox>
                }
              />}


          </LineUIContainer>
        </LineSettingsContainer>
      </MainContent>
    </Content>
  );
});

export default CameraConfiguration;